import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    cancel: 'Undo changes',
    checkbox: 'Do not remind me again',
    content:
      'You activated the e-mail reminder function when creating this invoice. Updating the client information resets these settings. Reactivate the email reminder in the "send reminder" panel before sending.',
    title: 'Update in Client Information',
    validate: 'Confirm changes',
  },
  fr: {
    cancel: 'Annuler le changement',
    checkbox: 'Ne plus me le rappeler',
    content:
      'Vous avez activé la fonction de relance par e-mail lors de la création de cette facture. La modification des informations client réinitialise ces paramètres.\nRéactivez la relance par e-mail dans le panneau “relance” avant l’envoi.',
    title: 'Mise à jour des informations client',
    validate: 'Confirmer le changement',
  },
} as const);

export default locales;
